import {Sidebar} from "./Sidebar";
import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../redux/hooks";
import {RootState} from "../redux/store";
import {ActiveContent} from "../redux/slices/content/contentType";
import {Dashboard} from "./Content/Dashboard";
import {Adventure} from "./Content/Adventure/Adventure";
import {Charakterbogen} from "./Content/Charakterbogen";
import {Inventar} from "./Content/Inventar";
import {Zauberbuch} from "./Content/Zauberbuch";
import {Autorisierung} from "./Content/Autorisierung";
import {AdventureCreate} from "./Content/Adventure/AdventureCreate";
import {AdventureMask} from "./Content/Adventure/AdventureMask";
import {AdventureCreateNPCPopUp} from "./Content/Adventure/AdventureTabs/AdventureCreateNPCPopUp";
import {AdventureSpellbookTab} from "./Content/Adventure/AdventureTabs/AdventureSpellbookTab";
import {AdventureCharacterSheetTab} from "./Content/Adventure/AdventureTabs/AdventureCharacterSheetTab";
import {Kampagne} from "./Content/Kampagne";
import {useMutation, useQuery} from "@apollo/client";
import {GetMessages} from "../GraphQL/MessageQuery";
import {setIsAppLoading} from "../redux/slices/content/contentSlice";
import {CloseSharp, NotificationsActiveSharp} from "@mui/icons-material";
import Button from "../Atoms/Button";
import {DeleteMessage, SetMessagesRead} from "../GraphQL/MessageMutation";
import {deleteAdventure} from "../GraphQL/AdventureMutation";
import {KampagneMask} from "./Content/Kampagne/KampagneMask";
import {SystemContent} from './Content/Standardinhalte/systemContent';
import {Voelker} from './Content/Standardinhalte/Voelker';
import {Subvoelker} from './Content/Standardinhalte/Subvoelker';
import {Klassen} from './Content/Standardinhalte/Klassen';
import {Subklassen} from './Content/Standardinhalte/Subklassen';
import {Manatabellen} from './Content/Standardinhalte/Manatabellen';
import {KampagneOverview} from "./Content/Kampagne/KampagneOverview";
import {TestPage} from "./Content/Standardinhalte/TestPage";

export const ContentRouter = (props: {}) => {
    const content = useAppSelector((state: RootState) => state.content);
    const user = useAppSelector((state: RootState) => state.user);
    const dispatch = useAppDispatch();

    const {
        data: messageData,
        loading: messageLoading,
        error: messageError
    } = useQuery(GetMessages, {
        variables: {userId: Number(user.userId)},
        fetchPolicy: 'network-only'
    })

    const [ areMessagesVisible, setAreMessagesVisible ] = React.useState<boolean>(false);
    const [
        messageReadMutation, {
            data: messageReadData,
            loading: messageReadLoading,
            error: messageReadError
        } ] = useMutation(SetMessagesRead)
    const [
        deleteMessageMutation, {
            data: deleteMessageData,
            loading: deleteMessageLoading,
            error: deleteMessageError
        } ] = useMutation(DeleteMessage)
    const [ messages, setMessages ] = React.useState<any[]>([]);

    useEffect(() => {
        if (messageData && !messageLoading) {
            setMessages(messageData.getMessages)
        }
    }, [ messageData ])

    useEffect(() => {
        if (messageLoading) {
            dispatch(setIsAppLoading({loadingText: 'Nachrichten werden geladen...', isAppLoading: true}))
        } else {
            dispatch(setIsAppLoading({loadingText: '', isAppLoading: false}))
        }
    }, [ messageLoading ])

    const handleActiveContent = () => {
        switch (content.activeContent) {
            default:
            case ActiveContent.Dashboard:
                return <Dashboard/>
            case ActiveContent.Adventure: {
                if (user.role > 1) {
                    return <Adventure/>
                }
                return
            }
            case ActiveContent.AdventureCreate: {
                if (user.role >= 2) {
                    return <AdventureCreate/>
                }
                return
            }
            case ActiveContent.AdventureMask: {
                if (user.role > 1) {
                    return <AdventureMask/>
                }
                return
            }
            case ActiveContent.Autorisierung: {
                if (user.role > 2) {
                    return <Autorisierung/>
                }
                return
            }
            case ActiveContent.Kampagne: {
                return <Kampagne/>
            }
            case ActiveContent.KampagnePlay: {
                return <KampagneOverview/>
            }
            case ActiveContent.Standardinhalte: {
                return <SystemContent/>
            }
            case ActiveContent.Voelker: {
                return <Voelker/>
            }
            case ActiveContent.Subvoelker: {
                return <Subvoelker/>
            }
            case ActiveContent.Klassen: {
                return <Klassen/>
            }
            case ActiveContent.Subklassen: {
                return <Subklassen/>
            }
            case ActiveContent.Manatabellen: {
                return <Manatabellen/>
            }
            case ActiveContent.Testpage: {
                return <TestPage/>
            }
        }
    }

    const renderOneMessage = (message: any) => {
        return (
            <div className='message-element col-11 text-start'>
                {message.messageText}
            </div>
        )
    }

    const renderMessages = () => {
        const html = [];
        for (const message of messages) {
            html.push(renderOneMessage(message))
        }

        return html;
    }

    const getNewNotificationsCount = () => {
        let count = 0;
        for (const message of messages) {
            if (!message.messageRead) {
                count++;
            }
        }

        return count;
    }

    const handleMessageClick = async () => {
        if (getNewNotificationsCount() !== 0 && areMessagesVisible) {
            await messageReadMutation({
                variables: {
                    userId: Number(user.userId)
                },
                refetchQueries: [
                    {
                        query: GetMessages,
                        variables: {
                            userId: Number(user.userId)
                        }
                    } ]
            })
        }
        setAreMessagesVisible(prevState => !prevState)

    }

    const handleDeleteMessages = async () => {
        const deleteList = [];
        for (const message of messages) {
            deleteList.push(Number(message.messageId))
        }

        await deleteMessageMutation({
            variables: {
                messages: deleteList
            },
            refetchQueries: [
                {
                    query: GetMessages,
                    variables: {
                        userId: Number(user.userId)
                    }
                } ]
        })

        setAreMessagesVisible(false)
    }

    return (
        <div>
            <div className='row content-header'>
                <div className='col-2 text-center'>
                    <span className='content-header-logo'>VENE DND</span>
                </div>
                <div className='col-8'/>
                <div className='col-2 justify-content-end'>
                    {getNewNotificationsCount() > 0 && (
                        <label className='message-label'>{getNewNotificationsCount()}</label>
                    )}
                    <Button className='notification-btn' onClick={() => handleMessageClick()}>
                        <NotificationsActiveSharp style={{color: 'white'}}/>
                    </Button>
                    {
                        areMessagesVisible && (
                            <div className='row message-container justify-content-center'>
                                <div className='col-10 mt-1'>Benachrichtigungen</div>
                                <div className='col-2 mt-1'>
                                    <label className='close-label' onClick={async () => await handleDeleteMessages()}>
                                        <CloseSharp/>
                                    </label>
                                </div>
                                {renderMessages()}
                            </div>
                        )
                    }
                </div>
            </div>
            <div className='row content-container'>
                <div className={content.isSidebarExpanded ? 'col-2' : 'col-1'}>
                    <Sidebar/>
                </div>
                {user.role < 1 && (
                    <div className={content.isSidebarExpanded ? 'col-10 mt-2' : 'col-11 mt-2'}>
                        <h3>Sie haben sich registriert, bitte warten Sie bis sie ihr Konto autorisiert wurde</h3>
                    </div>
                )}
                {user.role > 0 && (
                    <div className={content.isSidebarExpanded ? 'col-10' : 'col-11'}>
                        {handleActiveContent()}
                    </div>
                )}
            </div>
        </div>
    )
}